import { IoLogOutOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function Topbar({ title, onMenuClick }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  function handleLogout() {
    logout();
    navigate("/cmsadmin", { replace: true });
  }

  return (
    <header className="sticky top-0 z-20 flex items-center justify-between gap-4 border-b border-slate-200/80 bg-white/90 px-4 py-4 shadow-sm backdrop-blur sm:px-6">
      <div className="flex min-w-0 items-center gap-3">
        {onMenuClick ? (
          <button
            type="button"
            onClick={onMenuClick}
            className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-700 lg:hidden"
            aria-label="Open menu"
          >
            <span className="text-lg">☰</span>
          </button>
        ) : null}
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-emerald-600">
            CMS
          </p>
          <h1 className="truncate text-xl font-semibold text-slate-900">{title}</h1>
        </div>
      </div>

      <div className="flex shrink-0 items-center gap-3">
        {user?.username ? (
          <span className="hidden rounded-full bg-slate-100 px-3 py-1.5 text-sm text-slate-600 sm:inline">
            {user.username}
          </span>
        ) : null}
        <button
          type="button"
          onClick={handleLogout}
          className="inline-flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-50"
        >
          <IoLogOutOutline className="h-4 w-4" />
          Sign out
        </button>
      </div>
    </header>
  );
}
